module.exports = __webpack_public_path__ + "img/conve_text.483b499d.png";